import { CopyFieldDto } from '../dto/copy-field-dto';
import { RBCheck, ViewModelProperty, VmpSelectionType } from '@ldw/roesberg';
import { DocumentCopyDataGroup } from '../models/document-copydata-group';

export class CopyFieldFactory {
  static fromDTO(dtoList: CopyFieldDto[]): DocumentCopyDataGroup[] {
    const list: DocumentCopyDataGroup[] = [];
    if (!RBCheck.isNullOrHasNoValues(dtoList)) {
      dtoList.forEach(dto => {
        const item = this.convertField(dto);
        if (item) {
          if (!item.subGroupName) {
            item.subGroupName = "";
          }
          let group = list.find( x => x.groupName === item.subGroupName);
          if (group == undefined) {
            group = new DocumentCopyDataGroup();
            group.groupName = item.subGroupName;
            list.push(group);
          }
          group.fields?.push(item);
        }
      })
    }
    return list;
  }

  static convertField(dto: CopyFieldDto): ViewModelProperty | undefined {
    if (dto == undefined) {
      return undefined;
    }
    const vmp = new ViewModelProperty();
    vmp.fieldName = dto.fieldName;
    vmp.selectionType = VmpSelectionType.AutoComplete;
    vmp.fieldType = dto.fieldType;
    vmp.fieldLen = dto.fieldLen;
    vmp.listFunction = dto.listFunction;
    vmp.caption = dto.caption;
    vmp.infoText = dto.infoText;
    vmp.subGroupName = dto.subGroupName;
    vmp.value = dto.value;
    vmp.displayValue = dto.displayValue;
    if (vmp.fieldName === "DOCUMENT_NAVIGATION_PARENT_ID") {
      vmp.selectionType = VmpSelectionType.ButtonEdit;
    }

    if (vmp.fieldName === "BASIC_NAVIGATION_PARENT_ID") {
      vmp.selectionType = VmpSelectionType.ButtonEdit;
    }

    if (vmp.fieldName === "OWN_NAVIGATION_PARENT_ID") {
      vmp.selectionType = VmpSelectionType.ButtonEdit;
    }

    return vmp;
  }
}
